import { VehicleType } from "../types";

export function daysBetweenDates(
  startDateStr: string,
  endDateStr: string
): number {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Calculate the time difference in milliseconds
  const timeDifference = endDate.getTime() - startDate.getTime();

  // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
  const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000));

  return daysDifference;
}

export function getDatesInRange(startDate: Date, endDate: Date) {
  let dateArray = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dateArray.push(new Date(currentDate.setUTCHours(0, 0, 0, 0)).toISOString());
    currentDate.setDate(currentDate.getDate() + 1);
  }

  const newArr = new Set(dateArray);
  return Array.from(newArr);
}

const pad = (num: number) => (num < 10 ? "0" : "") + num;

export function formatDateToString(date: Date): string {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const milliseconds = pad(date.getMilliseconds());

  const timezoneOffset = -date.getTimezoneOffset();
  const sign = timezoneOffset >= 0 ? "+" : "-";
  const offsetHours = pad(Math.floor(Math.abs(timezoneOffset) / 60));
  const offsetMinutes = pad(Math.abs(timezoneOffset) % 60);

  const localISOString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${sign}${offsetHours}:${offsetMinutes}`;

  return localISOString;
}

export function getDatesBetweenRange(startDate: Date, endDate: Date): string[] {
  const dates: string[] = [];

  // Ensure that the start date is before or equal to the end date
  if (startDate > endDate) {
    throw new Error("The start date must be before or equal to the end date.");
  }

  // Create a new date object from the start date to retain its timezone
  let currentDate = new Date(startDate);

  // Add each date within the range to the array
  while (currentDate <= endDate) {
    dates.push(formatDateToString(new Date(currentDate)));

    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

export function getDateWithoutTime(date: string): string {
  return date.split("T")[0];
}

export function filterAvailableVehicles(
  vehicles: VehicleType[],
  startDate: string,
  endDate: string
): VehicleType[] {
  const dateRange = getDatesInRange(new Date(startDate), new Date(endDate));

  return vehicles.filter((vehicle) => {
    // Check if all dates in range are available and not reserved
    return dateRange.every(
      (date) =>
        vehicle.availability.includes(date) &&
        !vehicle.reservedDates.includes(date)
    );
  });
}

export function calculateAge(birthDateString: string) {
  const birthDate = new Date(birthDateString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

export function calculateInclusiveDateRange(
  _startDate: string,
  _endDate: string
) {
  // Ensure dates are in Date objects
  const startDate = new Date(_startDate);
  const endDate = new Date(_endDate);

  // Add one day to the end date to make the range inclusive
  // endDate.setDate(endDate.getDate() + 1);

  // Calculate the difference
  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}
